<template>
  <div class="app-buttons">
    <div class="back-button col" v-if="!isSuccess">
    <b-button @click="back">
          <slot name="btnBack">Zurück</slot>
    </b-button>
    </div>
    <b-overlay v-if="isDeactivable && !isSuccess" class="btn-next-overlay col" :show="loading_ && isDeactivable" spinner-small>
        <b-button class="btn-confirm"  @click="$emit('deactivate')">
          <slot name="btnDeactivate">Jetzt Deaktivieren</slot>
        </b-button>
    </b-overlay>
    <b-overlay v-if="isCancel && !isSuccess" class="btn-next-overlay col" :show="loading_ && isCancel" spinner-small>
        <b-button class="btn-confirm" @click="$emit('cancel')">
          <slot name="btnCancel">Jetzt Stornieren</slot>
        </b-button>
    </b-overlay>
    <div class="overview-button col">
        <b-button v-if="isSuccess" @click="back">
          <slot name="btnManage">MyFYVE Übersicht</slot>
        </b-button>
    </div>
  </div>
</template>
<script>

import { BButton } from 'bootstrap-vue'
import { mapMutations } from 'vuex'

export default {
  name: 'Buttons',
  components: { BButton },
  data () {
    return {
      visible: false,
      loading: false
    }
  },
  methods: {
    ...mapMutations('tariffs', [
      'changeView'
    ]),
    changeLoading (laoding) {
      this.loading = laoding
    },
    setStep (view) {
      this.changeView({ view: view })
    },
    back () {
      this.setStep('overview')
      this.$emit('refresh')
    },
    deactivateOption () {
      this.setStep('deactivate')
      this.$emit('selected')
    }
  },
  computed: {
    loading_: function () {
      return this.loading
    },
    isDeactivable: function () {
      return (!this.item.isPendingTariff && this.item.statusKey !== 'TER' && this.item.statusKey !== 'PDL' && this.item.statusKey !== 'IDL')
    },
    showChange: function () {
      return this.itemType !== 'serviceOption'
    },
    isCancel: function () {
      return this.item.isPendingTariff || false
    },
    isSuccess: function () {
      return this.success
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    success: {
      type: Boolean,
      default: false
    }
  }
}
</script>
